module.exports = __webpack_public_path__ + "media/img/comments-7a10b50c860f66786c6551a94be25927.svg";